import React, {Component} from 'react'
import {Redirect} from 'react-router-dom'
import {Helmet} from "react-helmet";
import * as config from '../Configuration/Config.js'

class ForgotPasswordConfirmation extends Component {
    constructor(props) {
        super()
        //console.log(props);

        this.handleSubmit = this.handleSubmit.bind(this)
        
        let incomingEmail = '';

        try {
            incomingEmail = props.location.state.EmailAddress;
        }
        catch(err) {}

        this.state = {
            EmailAddress: incomingEmail,
            redirect_login: false
        }
    
    }

    handleSubmit(event) {
        event.preventDefault();

        const np = event.target.elements.Password.value;
        const np2 = event.target.elements.PasswordConfirmation.value;
        
        if (np !== np2) {
            alert('Your conformation password does not match');
            return;
        }

        const data = {
            user_name: event.target.elements.EmailAddress.value,
            np: np,
            // PasswordConfirmation: event.target.elements.PasswordConfirmation.value,
            code: event.target.elements.ConfirmCode.value
        };

        var that = this;
        const uri = config.getUriPath('identity/password/forgot/confirmation');
        fetch(uri, {
            method: 'post',
            headers: config.ApiHeaders(),
            body: JSON.stringify(data)
        }).then(function(response) {
            if (response.status !== 200) {
              console.log(response);
              // throw new Error("Bad response from server");
              alert('Invalid password data');
              return;
            }

            that.setState({redirect_login: true})
        });
    }

    componentDidMount() {
        //console.log(this);
    }

    render() {

        if (this.state.redirect_login) {
            return <Redirect to='/login' />
        }

        return <div className="LogIn">
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Login</title>                        
                    </Helmet>                      
                    <div className="center-div">
                        <div className="outerLoginBox">
                            { /* <div className="innerLoginBox"> */ }
                                <div className="center-h-div">
                                    <img src={require('../../Images/acumen_full-color-web.png')} alt="Logo"/>
                                    <div className="loginMessage">Create Your New Password</div>
                                    <div className="alert alert-info">
                                        Please check your email for a confirmation code.
                                    </div>
                                    <br/>
                                    <div className="center-div">
                                        <form onSubmit={this.handleSubmit}> 
                                            <div className="form-group">
                                                <input 
                                                    name="EmailAddress" 
                                                    placeholder="Email Address" 
                                                    type="email"
                                                    className="form-control"
                                                    defaultValue={this.state.EmailAddress} /><br/>
                                                <input 
                                                    name="ConfirmCode" 
                                                    type="text"
                                                    placeholder="Confirmation Code" 
                                                    className="form-control" /><br/>
                                                <input 
                                                    name="Password" 
                                                    placeholder="New Password" 
                                                    type="password"
                                                    className="form-control" /><br/>
                                                <input 
                                                    name="PasswordConfirmation" 
                                                    placeholder="Confirm Password" 
                                                    type="password"
                                                    className="form-control" /><br/>
                                                    <div>Passwords must be at least 8 characters and must contain at least 1 upper case letter, 1 number, and 1 non-alphanumeric character</div>
                                                <button className="loginButton btn btn-primary">Reset Password</button>&nbsp;&nbsp;<a href="/login">Cancel</a>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="errorMsg">{this.state.error}</div>                            
                                </div>
                            { /* </div> */ }
                        </div>
                    </div>
                </div>
    }
}

export default ForgotPasswordConfirmation


// WEBPACK FOOTER //
// ./src/Components/Shared/ForgotPasswordConfirmation.js